import type {CSSProperties} from "react";

export const registerPromoTheme: CSSProperties = {
  "--banner-bg": "linear-gradient(135deg, #0d1f17 0%, #0f2a1c 40%, #122e20 70%, #0b1a12 100%)",
  "--banner-border": "rgba(0, 230, 118, 0.2)",
  "--banner-line": "linear-gradient(90deg, transparent, #00e676, #69f0ae, #00c853, transparent)",
  "--banner-sheen":
    "linear-gradient(120deg, transparent 30%, rgba(0, 230, 118, 0.03) 45%, rgba(105, 240, 174, 0.05) 50%, rgba(0, 230, 118, 0.03) 55%, transparent 70%)",
  "--banner-hover-shadow": "rgba(0, 230, 118, 0.15)",
  "--banner-hover-glow": "rgba(0, 230, 118, 0.06)",
  "--banner-hover-border": "rgba(0, 230, 118, 0.35)",
  "--glow-primary": "radial-gradient(circle, rgba(0, 230, 118, 0.12) 0%, rgba(0, 200, 83, 0.04) 40%, transparent 70%)",
  "--glow-secondary": "radial-gradient(circle, rgba(105, 240, 174, 0.08) 0%, transparent 70%)",
  "--badge-bg": "linear-gradient(135deg, rgba(0, 230, 118, 0.25) 0%, rgba(105, 240, 174, 0.15) 100%)",
  "--badge-border": "rgba(0, 230, 118, 0.4)",
  "--badge-ring": "rgba(0, 230, 118, 0.15)",
  "--badge-main-gradient": "linear-gradient(180deg, #ffffff, #ffffff)",
  "--badge-sub-color": "rgba(105, 240, 174, 0.7)",
  "--title-gradient": "linear-gradient(90deg, #fff, #69f0ae, #00e676, #69f0ae, #fff)",
  "--tag-bg": "rgba(0, 230, 118, 0.15)",
  "--tag-color": "#00e676",
  "--tag-border": "rgba(0, 230, 118, 0.2)",
  "--tag-dot": "#00e676",
  "--action-bg": "linear-gradient(135deg, #00e676 0%, #00c853 100%)",
  "--action-color": "#ffffff",
  "--action-shadow": "rgba(0, 230, 118, 0.4)",
  "--desc-color": "rgba(255, 255, 255, 0.55)",
  "--chip-bg": "linear-gradient(135deg, rgba(0, 230, 118, 0.2) 0%, rgba(0, 200, 83, 0.15) 100%)",
  "--chip-border": "rgba(0, 230, 118, 0.3)",
  "--chip-label-color": "rgba(255, 255, 255, 0.6)",
  "--chip-value-color": "#00e676",
};

export const cashbackPromoTheme: CSSProperties = {
  "--banner-bg": "linear-gradient(135deg, #1a1520 0%, #1e1228 40%, #221530 70%, #18101e 100%)",
  "--banner-border": "rgba(255, 153, 0, 0.2)",
  "--banner-line": "linear-gradient(90deg, transparent, #ff9900, #00CED1, #ff6600, transparent)",
  "--banner-sheen":
    "linear-gradient(120deg, transparent 30%, rgba(255, 153, 0, 0.03) 45%, rgba(255, 214, 0, 0.05) 50%, rgba(255, 153, 0, 0.03) 55%, transparent 70%)",
  "--banner-hover-shadow": "rgba(255, 153, 0, 0.15)",
  "--banner-hover-glow": "rgba(255, 153, 0, 0.06)",
  "--banner-hover-border": "rgba(255, 153, 0, 0.35)",
  "--glow-primary": "radial-gradient(circle, rgba(255, 153, 0, 0.12) 0%, rgba(255, 102, 0, 0.04) 40%, transparent 70%)",
  "--glow-secondary": "radial-gradient(circle, rgba(255, 214, 0, 0.08) 0%, transparent 70%)",
  "--badge-bg": "linear-gradient(135deg, rgba(255, 153, 0, 0.25) 0%, rgba(255, 214, 0, 0.15) 100%)",
  "--badge-border": "rgba(255, 153, 0, 0.4)",
  "--badge-ring": "rgba(255, 153, 0, 0.15)",
  "--badge-main-gradient": "linear-gradient(180deg, #00CED1, #ff9900)",
  "--badge-sub-color": "rgba(255, 214, 0, 0.7)",
  "--title-gradient": "linear-gradient(90deg, #fff, #00CED1, #ff9900, #00CED1, #fff)",
  "--tag-bg": "rgba(255, 153, 0, 0.15)",
  "--tag-color": "#ff9900",
  "--tag-border": "rgba(255, 153, 0, 0.2)",
  "--tag-dot": "#ff9900",
  "--action-bg": "linear-gradient(135deg, #ff9900 0%, #ff6600 100%)",
  "--action-color": "#ffffff",
  "--action-shadow": "rgba(255, 153, 0, 0.4)",
  "--desc-color": "rgba(255, 255, 255, 0.55)",
  "--chip-bg": "rgba(255, 153, 0, 0.1)",
  "--chip-border": "rgba(255, 153, 0, 0.2)",
  "--chip-label-color": "rgba(255, 255, 255, 0.4)",
  "--chip-value-color": "#ff9900",
};

export const mondaySpinsPromoTheme: CSSProperties = {
  "--banner-bg": "linear-gradient(135deg, #1a1030 0%, #1e1240 40%, #221450 70%, #160e28 100%)",
  "--banner-border": "rgba(0, 206, 209, 0.2)",
  "--banner-line": "linear-gradient(90deg, transparent, #00CED1, #66ecee, #00bfc2, transparent)",
  "--banner-sheen":
    "linear-gradient(120deg, transparent 30%, rgba(0, 206, 209, 0.03) 45%, rgba(51, 224, 226, 0.05) 50%, rgba(0, 206, 209, 0.03) 55%, transparent 70%)",
  "--banner-hover-shadow": "rgba(0, 206, 209, 0.15)",
  "--banner-hover-glow": "rgba(0, 206, 209, 0.06)",
  "--banner-hover-border": "rgba(0, 206, 209, 0.35)",
  "--glow-primary":
    "radial-gradient(circle, rgba(0, 206, 209, 0.12) 0%, rgba(0, 191, 194, 0.04) 40%, transparent 70%)",
  "--glow-secondary": "radial-gradient(circle, rgba(51, 224, 226, 0.08) 0%, transparent 70%)",
  "--badge-bg": "linear-gradient(135deg, rgba(0, 206, 209, 0.25) 0%, rgba(51, 224, 226, 0.15) 100%)",
  "--badge-border": "rgba(0, 206, 209, 0.4)",
  "--badge-ring": "rgba(0, 206, 209, 0.15)",
  "--badge-main-gradient": "linear-gradient(180deg, #b3f4f5, #00CED1)",
  "--badge-sub-color": "rgba(51, 224, 226, 0.7)",
  "--title-gradient": "linear-gradient(90deg, #fff, #66ecee, #00CED1, #66ecee, #fff)",
  "--tag-bg": "rgba(0, 206, 209, 0.15)",
  "--tag-color": "#66ecee",
  "--tag-border": "rgba(0, 206, 209, 0.2)",
  "--tag-dot": "#66ecee",
  "--action-bg": "linear-gradient(135deg, #00CED1 0%, #00bfc2 100%)",
  "--action-color": "#ffffff",
  "--action-shadow": "rgba(0, 206, 209, 0.4)",
  "--desc-color": "rgba(255, 255, 255, 0.55)",
  "--chip-bg": "rgba(0, 206, 209, 0.1)",
  "--chip-border": "rgba(0, 206, 209, 0.2)",
  "--chip-label-color": "rgba(255, 255, 255, 0.4)",
  "--chip-value-color": "#66ecee",
};

export const dailySpinsPinkTheme: CSSProperties = {
  "--banner-bg": "linear-gradient(135deg, #2a1022 0%, #351433 40%, #3f173d 70%, #240d22 100%)",
  "--banner-border": "rgba(255, 64, 129, 0.2)",
  "--banner-line": "linear-gradient(90deg, transparent, #ff4081, #ff80ab, #f50057, transparent)",
  "--banner-sheen":
    "linear-gradient(120deg, transparent 30%, rgba(255, 64, 129, 0.03) 45%, rgba(255, 128, 171, 0.05) 50%, rgba(255, 64, 129, 0.03) 55%, transparent 70%)",
  "--banner-hover-shadow": "rgba(255, 64, 129, 0.15)",
  "--banner-hover-glow": "rgba(255, 64, 129, 0.06)",
  "--banner-hover-border": "rgba(255, 64, 129, 0.35)",
  "--glow-primary": "radial-gradient(circle, rgba(255, 64, 129, 0.12) 0%, rgba(245, 0, 87, 0.04) 40%, transparent 70%)",
  "--glow-secondary": "radial-gradient(circle, rgba(255, 128, 171, 0.08) 0%, transparent 70%)",
  "--badge-bg": "linear-gradient(135deg, rgba(255, 64, 129, 0.25) 0%, rgba(255, 128, 171, 0.15) 100%)",
  "--badge-border": "rgba(255, 64, 129, 0.4)",
  "--badge-ring": "rgba(255, 64, 129, 0.15)",
  "--badge-main-gradient": "linear-gradient(180deg, #ffc1e3, #ff4081)",
  "--badge-sub-color": "rgba(255, 128, 171, 0.75)",
  "--title-gradient": "linear-gradient(90deg, #fff, #ff80ab, #ff4081, #ff80ab, #fff)",
  "--tag-bg": "rgba(255, 64, 129, 0.15)",
  "--tag-color": "#ff80ab",
  "--tag-border": "rgba(255, 64, 129, 0.2)",
  "--tag-dot": "#ff80ab",
  "--action-bg": "linear-gradient(135deg, #ff4081 0%, #f50057 100%)",
  "--action-color": "#ffffff",
  "--action-shadow": "rgba(255, 64, 129, 0.4)",
  "--desc-color": "rgba(255, 255, 255, 0.55)",
  "--chip-bg": "rgba(255, 64, 129, 0.1)",
  "--chip-border": "rgba(255, 64, 129, 0.2)",
  "--chip-label-color": "rgba(255, 255, 255, 0.4)",
  "--chip-value-color": "#ff80ab",
};

export const thursdaySpinsRedTheme: CSSProperties = {
  "--banner-bg": "linear-gradient(135deg, #2a1010 0%, #341313 40%, #3f1818 70%, #240d0d 100%)",
  "--banner-border": "rgba(255, 82, 82, 0.22)",
  "--banner-line": "linear-gradient(90deg, transparent, #ff5252, #ff8a80, #ff1744, transparent)",
  "--banner-sheen":
    "linear-gradient(120deg, transparent 30%, rgba(255, 82, 82, 0.03) 45%, rgba(255, 138, 128, 0.05) 50%, rgba(255, 82, 82, 0.03) 55%, transparent 70%)",
  "--banner-hover-shadow": "rgba(255, 82, 82, 0.15)",
  "--banner-hover-glow": "rgba(255, 82, 82, 0.06)",
  "--banner-hover-border": "rgba(255, 82, 82, 0.35)",
  "--glow-primary": "radial-gradient(circle, rgba(255, 82, 82, 0.12) 0%, rgba(255, 23, 68, 0.04) 40%, transparent 70%)",
  "--glow-secondary": "radial-gradient(circle, rgba(255, 138, 128, 0.08) 0%, transparent 70%)",
  "--badge-bg": "linear-gradient(135deg, rgba(255, 82, 82, 0.25) 0%, rgba(255, 138, 128, 0.15) 100%)",
  "--badge-border": "rgba(255, 82, 82, 0.4)",
  "--badge-ring": "rgba(255, 82, 82, 0.15)",
  "--badge-main-gradient": "linear-gradient(180deg, #ffd0d0, #ff5252)",
  "--badge-sub-color": "rgba(255, 138, 128, 0.75)",
  "--title-gradient": "linear-gradient(90deg, #fff, #ff8a80, #ff5252, #ff8a80, #fff)",
  "--tag-bg": "rgba(255, 82, 82, 0.15)",
  "--tag-color": "#ff8a80",
  "--tag-border": "rgba(255, 82, 82, 0.2)",
  "--tag-dot": "#ff8a80",
  "--action-bg": "linear-gradient(135deg, #ff5252 0%, #ff1744 100%)",
  "--action-color": "#ffffff",
  "--action-shadow": "rgba(255, 82, 82, 0.4)",
  "--desc-color": "rgba(255, 255, 255, 0.55)",
  "--chip-bg": "rgba(255, 82, 82, 0.1)",
  "--chip-border": "rgba(255, 82, 82, 0.2)",
  "--chip-label-color": "rgba(255, 255, 255, 0.4)",
  "--chip-value-color": "#ff8a80",
};
